import { listTemplate } from "api";
import { Error } from "utils/Response";
import { ActionTypes } from "./types";

export const ListTemplate = () => async (dispatch) => {
  try {
    dispatch({ type: ActionTypes.LOADING });
    const { data } = await listTemplate();
    dispatch({
      type: ActionTypes.SUCCESS,
      payload: data,
    });
  } catch (error) {
    Error(error?.response?.data?.error);
    dispatch({
      type: ActionTypes.ERROR,
      payload: error,
    });
  }
};
